import React from "react";
import "./Searchnav.css";
import WelcomeName from "./WelcomeName";
function Searchnav() {
  return (
    <>
      <div class="searchnav-container">
        <div class="searchnav-wrap">
          <div class="searchnav-row">
            <div
              class="searchnav-box"
              style={{ textAlign: "left", marginTop: "5px" }}
            >
              <img
                src="images/Acc_Logo_Black_Purple_RGB.png"
                class="acc-logo"
                alt="logo"
              />
              <p class="desktop-tag">LKM</p>
              <p class="mobile-tag">LKM</p>
            </div>
          </div>
          <div class="searchnav-row">
            <div
              class="searchnav-box"
              style={{ textAlign: "right", marginTop: "5px" }}
            >
              <WelcomeName />
              <img src="images/Avatar.png" class="user-img" alt="user-image" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Searchnav;
